import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
import scrollEffect from "./lib/scrollEffect.js";
// import { isPage } from "./lib/util";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
// import topValidation from 'top-validation';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
  scrollEffect();
});

document.addEventListener('DOMContentLoaded', () => {

  /*------------ オープニングアニメーション ------------*/
  const keyName = 'visited';
  const keyValue = true;
  const tl = gsap.timeline();

  if (!sessionStorage.getItem(keyName)) {
    sessionStorage.setItem(keyName, keyValue);
    tl
    .from('.opening_block', {
      autoAlpha: 1,
      delay: .2
    })
    .to('.opening_elements', {
      duration: .5,
      opacity: 1,
    }, '+=.2')
    .to('.opening_bg_img img', {
      onComplete: () => {
        document.querySelector('.opening_bg_img img').classList.add('is-active');
      }
    }, '+=.7')
    .to('.opening_elements', {
      delay: 0.2,
      duration: .2,
      opacity: 0,
    }, '+=.6')
    .to('.opening_block', {
      autoAlpha: 0,
      delay: .1,
      duration: 1
    }, '+=.2')
  } else {
    gsap.set('.opening_block', { display: 'none' });
  }

  /*------------ デバイス幅 ------------*/
  var winW = $(window).width();
  var spW = 870;

  /*------------ パララックス背景 ------------*/
  // GSAPとScrollTriggerを登録
  gsap.registerPlugin(ScrollTrigger);

  // デバイスの幅に応じて異なる値を設定する関数
  function getParallaxYValue() {
    if (window.matchMedia("(max-width: 768px)").matches) {
      // スマホサイズのとき
      return -50; // スマホ用のY値
    } else {
      // パソコンサイズのとき
      return -120; // パソコン用のY値
    }
  }

  // 各要素に対してパララックスアニメーションを設定
  gsap.utils.toArray('.js-parallax').forEach(wrap => {
    const y = getParallaxYValue(); // デバイスに応じたY値を取得

    gsap.to(wrap, {
      y: y,
      scrollTrigger: {
        trigger: wrap,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 5,
      }
    });
  });

  // ウィンドウサイズ変更時に再計算してアニメーションを更新
  window.addEventListener('resize', () => {
    gsap.utils.toArray('.js-parallax').forEach(wrap => {
      const y = getParallaxYValue();
      gsap.to(wrap, {
        y: y,
        scrollTrigger: {
          trigger: wrap,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 5,
        }
      });
    });
  });

  /*------------ ハンバーガーボタン ------------*/
  let isAnimated = false;
  let btntl;
  const btnLi = gsap.utils.toArray(".hd_global_nav li a");

  if (winW < spW) {

    document.querySelector(".trigger-btn").addEventListener("click", function () {
      if (!isAnimated) {
        btntl = gsap.timeline(); // Timelineインスタンスを作成

        btntl
        .to(".trigger-btn",{
          duration: 0.1,
        },"-=0.7")
        .add(() => {
          // addメソッド内でクラスを追加する
          document.querySelector(".trigger-btn").classList.toggle("is-active");
        })
        .to("#header", {
          height: "100vh",
          duration: 0.2,
          ease: "power4.out",
        },)
        .to(".hd_wrap", {
          margin: "6vh 0 0",
          height: "auto",
          duration: 0.1,
          ease: "power4.out",
        },)
        .staggerTo(btnLi, 0.5,{
          opacity: 1,
          ease: "power1.out",
        }, 0.1,"=0.1" )
        .to(".cmn_mail_txt",{
          opacity: 1,
        }, )
        .to(".cmn_tel_btn",{
          opacity: 1,
        }, "-=0.3" )
        .to(".cmn_hours_txt",{
          opacity: 1,
        }, "-=0.1" )
        isAnimated = true;
      } else {
        btntl.reverse(1); // アニメーションを逆再生
        isAnimated = false;
      }
    });
  }

  /*------------ よくいただくご質問 ------------*/
  const buttons = document.querySelectorAll('.faq_btn');

  buttons.forEach((button) => {
    button.addEventListener('click', (e) => {
      const menu = e.currentTarget; // クリックされた要素
      const body = menu.querySelector('.answer_item'); // クリックされた要素内の .answer_item を取得
      const textHeight = body.scrollHeight; // コンテンツ全体の高さを取得
      menu.classList.toggle('open');

      // 条件分岐で開閉を切り替える
      if(menu.classList.contains('open')) {
        body.style.height = textHeight + 'px';
      } else {
        body.style.height = 0;
      }
    });
  });

});//document.addEventListener


/*------------ メインイメージ------------*/
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(function() {
    document.querySelector('.mainimg').classList.add('is-visible');
  }, 800);
});

/*------------ ページタイトルの装飾ライン------------*/
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(function() {
    document.querySelector('.ttl_line').classList.add('is-visible');
  }, 800);
});

/*------------ メインコピー------------*/
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(function() {
    document.querySelector('.index_mainimg_txt').classList.add('is-visible');
  }, 800);
});

/*------------ 固定ヘッダー 出現------------*/
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(function() {
    document.querySelector('#header').classList.add('is-visible');
  }, 500);
});

/*------------ 固定ヘッダー ------------*/
window.addEventListener('scroll', () => {
  var header = document.getElementById('header');
  if (window.scrollY > 50) {
    header.classList.add('is-active');
  } else {
    header.classList.remove('is-active');
  }
});

/*------------ タイトルアニメーション ------------*/
document.addEventListener("DOMContentLoaded", () => {
  const animationTargetElements = document.querySelectorAll(".js-txt-anime");
  const ttlLineElements = document.querySelectorAll('.ttl_line');

  // IntersectionObserverのコールバック関数
  const observerCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const targetElement = entry.target;

        // 0.5秒の遅延を追加
        setTimeout(() => {
          // アニメーションを開始する前に透明度をリセット
          targetElement.style.opacity = 1;

          const texts = targetElement.textContent; // texts を定義
          const textsArray = [];

          targetElement.textContent = "";

          for (let j = 0; j < texts.split("").length; j++) {
            const character = texts.split("")[j];
            if (character === " ") {
              // 半角スペースの場合、&nbsp;で処理
              textsArray.push('<span><span style="animation-delay: '+ ((j+0.4) * 0.1) +'s" >&nbsp;<span></span>');
            } else {
              textsArray.push('<span><span style="animation-delay: '+ ((j+0.4) * 0.1) +'s" >' + character + '<span></span>');
            }
          }

          for (let k = 0; k < textsArray.length; k++) {
            targetElement.innerHTML += textsArray[k];
          }

          // アニメーションが終わったらObserverをオフにする（必要に応じて）
          observer.unobserve(targetElement);
        }, 500); // 0.7秒の遅延
      }
    });
  };

  // .js-txt-anime要素用のObserver
  const animationObserver = new IntersectionObserver(observerCallback);
  animationTargetElements.forEach(element => {
    animationObserver.observe(element);
  });

  // .ttl_line要素用のObserver
  const ttlLineObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        ttlLineObserver.unobserve(entry.target);
      }
    });
  });

  ttlLineElements.forEach(element => {
    ttlLineObserver.observe(element);
  });
});


/*------------ 慣性スクロール Lenis ------------*/
const lenis = new Lenis()
function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}
requestAnimationFrame(raf)


/*------------ アンカーリンク ------------*/
document.addEventListener('DOMContentLoaded', function() {
  // location.hashからURLのハッシュを取得
  var urlHash = location.hash;
  if (urlHash) {
    // ページ読み込み時にスクロール位置をトップに設定
    window.scrollTo(0, 0);

    setTimeout(function() {
      // ヘッダーの高さを設定 (200pxをデフォルト値として使用)
      var headerHeight = 200;

      // モバイル端末の場合、ヘッダーの高さを0に設定
      if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
        headerHeight = 170;
      }

      // ターゲット要素を取得し、スクロール位置を計算
      var target = document.querySelector(urlHash);
      if (target) {
        var position = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        // スムーズスクロールで指定した位置まで移動
        window.scrollTo({
          top: position,
          behavior: 'smooth'
        });
      }
    }, 100); // 100ミリ秒後に実行
  }
});
